import useAppStore from "@/context/store";
import { isInPinDetailModal } from "@/utils/getPinDetailModal";
import { useMemoizedFn } from "ahooks";
import { NextRouter, useRouter } from "next/router";

/**
 * 用于页面内跳转到pin详情页，会根据当前是否为modal来决定是否使用history.pushState
 * @param param0
 * @param param0.pinId 采集id
 * @param param0.children 用于包裹的元素
 * @param param0.urlParams 附加的url参数 例如：from=home
 * @returns
 */
export default function PinLink({
  pinId,
  children,
  urlParams = "",
}: {
  pinId: string | number;
  children?: React.ReactNode;
  urlParams?: string;
}) {
  const router = useRouter();

  const onLink = useMemoizedFn(() => {
    goToPinPage({ pinId, urlParams, router });
  });

  return <div onClick={onLink}>{children}</div>;
}

/**
 * 用于页面内跳转到pin详情页，会根据当前是否为modal来决定是否使用history.pushState
 * @param param0
 * @param param0.pinId 采集id
 * @param param0.router Next路由，用于页面跳转
 * @param param0.urlParams 附加的url参数 例如：from=home
 * @returns
 */
export function goToPinPage({
  pinId,
  urlParams = "",
  router,
}: {
  pinId: string | number;
  urlParams?: string;
  router: NextRouter;
}) {
  const isModal = isInPinDetailModal();
  const url = `/pins/${pinId}` + (urlParams ? `?${urlParams}` : "");

  if (isModal) {
    // 使用堆栈方式管理弹窗
    const { pushPinToStack } = useAppStore.getState();
    pushPinToStack({
      pinId: String(pinId),
      allowEmpty: true, // 标记允许空数据，因为 PinLink 没有完整数据
    });
    let historyData = typeof history?.state === "object" ? history?.state : {};
    // 使用 pinId 而不是 stackIndex 来标识弹窗
    // 添加序列号用于判断前进/后退方向
    const nextSeq = (historyData.seq || 0) + 1;
    window.history.pushState(
      {
        ...historyData,
        modalPinId: String(pinId),
        isModal: true,
        seq: nextSeq,
      },
      null,
      url
    );
  } else {
    router.push(url);
  }
}
